<div class="container isBackgoround" style="padding: 0px;">
  <main>
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
      class="container_min v-application v-application--is-ltr theme--light"
    >
      <h1 class="mb-10 h3" style="margin-top: 40px">
        パスワード再設定リンク送信完了
      </h1>
      <div
        class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
      ></div>
      <img
        class="mb-10"
        width="170px"
        src="/assets/collabo-portal/images/icon_mail.svg"
        alt=""
      />

      <div class="mb-10">パスワード再設定リンクをメールで送信しました。</div>

      <div
        class="mb-10 v-card v-sheet theme--light elevation-0"
        style="
          width: 500px;
          background-color: var(--color-100-bold);
          border-color: var(--color-100-bold);
        "
      >
        <div class="v-card__title text-caption">
          <div style="padding: 10px">
            <p
              class="text-subtitle-1 d-flex align-center mb-2"
              style="height: 28px; display: flex; justify-content: center"
            >
              <!-- <i
                id="icon-question"
                aria-hidden="true"
                class="v-icon notranslate v-icon--left mdi mdi-help-circle theme--right"
              ></i> -->
              <span class="v-text">認証メールが届かない場合</span>
            </p>
            <p class="text-black-58">
              dx-utility.comのドメインからメールが届きます。
              認証メールが届かない場合は、迷惑メールフォルダに入る設定となっていないかご確認ください。
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>